export enum WayOfUseEnum {
  Other = 'other',
  Private = 'private',
  SoleTrader = 'sole_trader',
}
